/* unplugin-vue-components disabled */import { render } from "./BaseNoData.vue?vue&type=template&id=36870d60"
import script from "./BaseNoData.vue?vue&type=script&lang=js"
export * from "./BaseNoData.vue?vue&type=script&lang=js"

import "./BaseNoData.vue?vue&type=style&index=0&id=36870d60&lang=scss"
script.render = render

export default script